import OrganizationApi from 'entities/organization/api';

import { useQuery } from '../useQuery';

import Organization from './model';

export const searchThreshold = 2;

export const useOrganizations = (search?: string, skip?: boolean) =>
  useQuery(
    async () =>
      (search?.length || 0) > searchThreshold
        ? (OrganizationApi.fetchAll(search).toPromise() as Promise<Organization[]>)
        : [],
    [],
    search,
    skip
  );
